
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface PiSegment {
  label: string;
  value: string | number | boolean | null;
  count?: number;
}

@Component
export default class PiSegments extends Vue {
  @Prop({ required: true }) segments!: PiSegment[];
  @Prop({ default: null }) value!: string | number | boolean | null;
}
